import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CmpsIconModule, CmpsIconRegistry } from '@cmps/ng-uikit';
import { mdiAccountCircle, mdiBriefcaseVariantOutline } from '@mdi/js';

import { CmpsCardHeaderRowComponent } from './card-header-row.component';

@NgModule({
    declarations: [CmpsCardHeaderRowComponent],
    exports: [CmpsCardHeaderRowComponent],
    imports: [CmpsIconModule, CommonModule],
})
export class CmpsCardHeaderRowComponentModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['account-circle', mdiAccountCircle],
            ['briefcase-variant', mdiBriefcaseVariantOutline],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
